import React, { useState, useMemo, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import CustomCheckboxFilter from "../../../utils/CustomCheckboxFilter";
import CustomToggleButton from "../../../utils/CustomToggleButton";
import SearchFilter from "../../../utils/SearchFilter";
import MatchCustomButton from "../../../utils/MatchCustomButton";


ModuleRegistry.registerModules([AllCommunityModule]);

const OperatorTable = ({operatorData,onEdit, onDelete,getOperators }) => {   
  const [rowData, setRowData] = useState([]);
  const [quickFilterText, setQuickFilterText] = useState("");
  const gridRef = useRef(null);

  

  useEffect(() => {
    setRowData(operatorData);
  }, [operatorData]);

  const onGridReady = (params) => {
    gridRef.current = params.api;
  };

  const handleQuickFilterChange = (e) => {
    setQuickFilterText(e.target.value);
  };

     const autoSizeStrategy = useMemo(() => {
          return {
              type: 'fillGrid ',
          };
      }, []);

  const columnDefs = useMemo(
    () => [
       {
      headerName: "Sl.No",
      valueGetter: (params) => {
        const currentPage = params.api.paginationGetCurrentPage();
        const pageSize = params.api.paginationGetPageSize();
        const rowIndex = params.node.rowIndex;
        return currentPage * pageSize + rowIndex + 1;
      },
      maxWidth: 100,
    },
    { headerName: "Operator Id", field: "operator_id", filter: CustomCheckboxFilter,flex:1 },
    { headerName: "Callback Url", field: "callback_url", filter: CustomCheckboxFilter,flex:1 },
    { headerName: "Environment", field: "environment", filter: CustomCheckboxFilter,flex:1 },
    { headerName: "Status", field: "status", filter: CustomCheckboxFilter, cellRenderer: CustomToggleButton,flex:1, cellRendererParams: {
      refreshList: getOperators,  // pass refresh callback
    }, },
    {
      headerName: "Actions",
      field: "actions",
     flex:1,
       cellRenderer: MatchCustomButton,

    },
    ],
    []
  );

  return (
    <>
      <div className="mb-4">
        <SearchFilter
          value={quickFilterText}
          onChange={handleQuickFilterChange}
        />
      </div>

      <div className="ag-theme-alpine" style={{ height: 750, width: "100%" }}>
        <AgGridReact
          ref={gridRef}
          quickFilterText={quickFilterText}
          rowData={rowData}
          columnDefs={columnDefs}
          pagination={true}
          paginationPageSize={20}
          context={{ onEdit, onDelete }}
          onGridReady={onGridReady}
          autoSizeStrategy={autoSizeStrategy}
          enableCellTextSelection={true}
          overlayNoRowsTemplate="<span style='padding: 10px; display: block;'>No data found</span>"
          onFilterChanged={(params) => {
            const rowCount = params.api.getDisplayedRowCount();
            if (rowCount === 0) {
              params.api.showNoRowsOverlay();
            } else {
              params.api.hideOverlay();
            }
          }}
        />
      </div>
    </>
  );
};

export default OperatorTable;
